import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Typography,
  Select,
  InputNumber,
  Divider,
  Spin,
  Collapse
} from 'antd';
import '../Common/Form.css';

import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { debounce } from '../Common/Debounce';
import { getSubunits } from '../../services/subunitService';
import { formatSubunits } from '../../utilities/subunitFormat';
import ImageUploadSection from '../ImageUploadSection';
import { beforeImageUpload } from '../../utilities/imageUpload';
import NotedFormItem from '../Common/NotedFormItem';
const { Text } = Typography;
const { Panel } = Collapse;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 20 }
  }
};
const formItemLayoutWithOutLabel = {
  wrapperCol: {
    xs: { span: 24, offset: 0 },
    sm: { span: 20, offset: 4 }
  }
};

const UnitForm = ({
  initialValues,
  onSubmit,
  status,
  type,
  setStatus,
  currentSubunits
}) => {
  const [fetching, setFetching] = useState(false);
  const [subunits, setSubunits] = useState([]);
  const [form] = Form.useForm();
  const fetchSubunitHandler = debounce((value) => {
    setFetching(true);
    getSubunits(1, 20, { subunitSearch: value })
      .then((response) => {
        const subunits = response.data.paginatedList;
        const data = formatSubunits(subunits);
        setSubunits(data);
        setFetching(false);
      })
      .catch((error) => {
        if (error?.response?.data?.message)
          setStatus({
            type: 'ERROR',
            message: error.response.data.message
          });
        else
          setStatus({
            type: 'ERROR',
            message: 'Getting questions from the backend failed!'
          });
      });
  }, 250);

  const getSubunitLabelText = (index) => {
    const selectedSubunit = currentSubunits.filter(
      (subunit) => subunit._id === form.getFieldValue(['subunits', index])
    );

    return selectedSubunit[0]
      ? `${selectedSubunit[0].code} - ${selectedSubunit[0].description}`
      : '';
  };

  return (
    <div className="course-add-form">
      <Form
        labelCol={{ span: 7 }}
        onFinish={onSubmit}
        initialValues={initialValues}
        form={form}>
        <section>
          <Form.Item
            label="Code"
            name="code"
            rules={[
              { required: true, message: 'Please input course code!' }
            ]}>
            <Input />
          </Form.Item>
          <Form.Item
            label="Title"
            name="title"
            rules={[{ required: true, message: 'Please input title!' }]}>
            <Input />
          </Form.Item>
          <Form.Item
            label="Description"
            name="description"
            rules={[
              {
                required: false,
                message: 'Please input code description!'
              }
            ]}>
            <Input />
          </Form.Item>
          <Form.Item
            label="Section Number"
            name="sectionNumber"
            rules={[{ required: false }]}>
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item
            label="Long Description"
            name="longDescription"
            rules={[
              {
                required: false,
                message: 'Please input code long description!'
              }
            ]}>
            <Input />
          </Form.Item>
          <Form.Item
            label="Header Of The Day"
            name="headerOfTheDay"
            rules={[
              {
                required: false,
                message: 'Please input code long description!'
              }
            ]}>
            <Input />
          </Form.Item>
          <Form.Item
            label="Description of the Day"
            name="descOfTheDay"
            rules={[
              {
                required: false,
                message: 'Please input code long description!'
              }
            ]}>
            <Input />
          </Form.Item>
        </section>
        <Collapse>
          <Panel
            header="Unit image in learning portal - for Live courses"
            key="3">
            <section>
              <ImageUploadSection
                beforeImageUpload={beforeImageUpload}
                nest={['imgData']}
                path={`na-portal/liveUnitThumbnails/`}
                bucket={'image-assets.nasdaily.com'}
                setStatus={setStatus}
                form={form}
                showWebP={true}
                imgRequired={false}
              />
            </section>
          </Panel>
        </Collapse>

        <Divider />
        <section className="course-add-subunit-section">
          <Text strong="true">Subunits</Text>
          {
            <Form.List
              name={['subunits']}
              label="subunits"
              rules={[{ required: true, message: 'Please add subunits' }]}>
              {(fields, { add, remove }) => (
                <>
                  {fields.map((field, index) => (
                    <>
                      <div
                        key={field.key}
                        style={{ display: 'flex', marginBottom: '10px' }}>
                        <Form.Item
                          {...field}
                          {...(index === 0
                            ? formItemLayout
                            : formItemLayoutWithOutLabel)}
                          label={index === 0 ? 'Subunit' : ''}
                          style={{ margin: '5px', width: '90%' }}
                          fieldKey={[field.fieldKey, '_id']}
                          rules={[{ required: false }]}>
                          <Select
                            mode={''}
                            placeholder="Search subunits"
                            notFoundContent={
                              fetching ? <Spin size="small" /> : null
                            }
                            filterOption={false}
                            showSearch={true}
                            onSearch={fetchSubunitHandler}
                            dropdownRender={(menu) => <div>{menu}</div>}>
                            {subunits?.map((item) => (
                              <Select.Option value={item.value}>
                                <Collapse>
                                  <Panel header={item.courseCode} key="1">
                                    <p>
                                      <b>Subunit code: </b>
                                      {item.courseCode}
                                    </p>
                                    <p>
                                      <b>SubUnits ID: </b>
                                      {item.value}
                                    </p>
                                  </Panel>
                                </Collapse>
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                        <div style={{ width: '5%', margin: '5px' }}>
                          <MinusCircleOutlined
                            onClick={() => remove(field.name)}
                          />
                        </div>
                      </div>
                      {type === 'Update' && currentSubunits[field.name] && (
                        <>
                          <div style={{ marginTop: '-12px' }}>
                            {getSubunitLabelText(field.name)}
                          </div>
                          <hr />
                        </>
                      )}
                    </>
                  ))}
                  <Form.Item>
                    <Button
                      type="dashed"
                      style={{ width: '50%' }}
                      onClick={() => {
                        add();
                      }}
                      icon={<PlusOutlined />}>
                      Add subunit
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          }
        </section>

        {status.type === 'ERROR' ? (
          <Text type="danger">{status.message}</Text>
        ) : null}
        {status.type === 'SUCCESS' ? (
          <Text type="success">Successful!</Text>
        ) : null}
        <Row justify="end" gutter={12}>
          <Col>
            <Button type="primary" htmlType="submit">
              {type}
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default UnitForm;
